<template>
  <div
    v-if="successPage"
    class="two-factor-link-verification-success"
  >
    <img
      alt="Green badge with white checkmark"
      loading="lazy"
      height="45px"
      width="45px"
      src="@/assets/images/green-checkmark-badge.svg"
    >
    <header
      class="two-factor-link-verification-success-header"
    >
      The link was successfully verified
    </header>
    <p class="two-factor-link-verification-success-text">
      Please close this tab and continue with your Official USPS® Change-of-Address form.
    </p>
  </div>
</template>

<script>
import pageName from '../../utils/pageName';
import { getPageProperties, getContext } from '../../utils/analyticsHelpers';

export default {
  name: 'TwoFactorLinkVerificationSuccess',
  data: () => ({
    successPage: true,
  }),
  async mounted() {
    window.analytics.page(pageName, getPageProperties(this.$route), getContext());

    const { uniqueId } = this.$route.query;
    if (uniqueId) {
      this.successPage = true;
      await this.verficationSuccess(uniqueId);
    }
  },
  methods: {
    async verficationSuccess(coaUUID) {
      if (this.$store.get('config@twoFactorAuthSecureMfaEnabled')) {
        const { validationStatus } = await this.$store.dispatch('mfa/validateLink', coaUUID);
        window.console.log(`coaUUID: ${coaUUID} Validate link response: ${validationStatus}`);
      }
    },
  },
};
</script>
<style>
.two-factor-link-verification-success {
  margin: auto;
  padding: 120px 20px 200px 20px;
  max-width: 446px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.two-factor-link-verification-success-header {
  padding: 10px 0 20px 0;
  color: var(--usps-digital-green);
  font-weight: 700;
  font-size: 1.25em;
}
.two-factor-link-verification-success-text {
  text-align: center;
}
</style>
